// extracted by mini-css-extract-plugin
export default {"GoodSelector":"GoodSelector_GoodSelector__bIxo6"};